<!--
 * @Description: 
 * @Author: cooky
 * @Date: 2021-02-25 17:17:51
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-01 19:17:42
-->
<template>
  <div v-if="maskClosable" :class="['modal', {active: visible}]" @click="clickMask">
    <slot></slot>
  </div>
  <div v-else :class="['modal', {active: visible}]">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'SModal',
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    },
    maskClosable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    clickMask (e) {
      if (e.target === e.currentTarget) {
        this.$emit('cancel')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.modal {
  display: flex;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 2020;
  opacity: 0;
  visibility: hidden;
  transition: opacity .5s,
              visibility .5s;
  background: rgba(0, 0, 0, .5);
  &.active {
    transition: opacity .5s;
    opacity: 1;
    visibility: visible;
  }
}
.content-box {
  display: flex;
  top: 0;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 2021;
}
</style>
